import { render } from "./JiangxiMap.vue?vue&type=template&id=1142ecf6&scoped=true"
import script from "./JiangxiMap.vue?vue&type=script&lang=js"
export * from "./JiangxiMap.vue?vue&type=script&lang=js"

import "./JiangxiMap.vue?vue&type=style&index=0&id=1142ecf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1142ecf6"]])

export default __exports__